// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("custom-product-price-block");
console.log(header)
if ( header != "" && header != null ) 
{

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("price-sticky");
  } else {
    header.classList.remove("price-sticky");
  }
}

}
$(document).ready(function(){
  var dra = new theme.Drawers('CartDrawer', 'cart');
  var discountPercentage = $(".product-section").attr("percentage-discount");
  if ( discountPercentage != "" && discountPercentage !=   undefined )
  {
    discountPercentage = discountPercentage.replace("%","");
  }
  discountPercentage = parseInt(discountPercentage)
  discountPercentage = discountPercentage / 100;
  var currencyFormat = $("html").attr("currenct-form");
  $(".product-m-b-t-co").on("click", function(){
    $(this).parents(".product-mega-bundle-options").toggleClass("act-accordian");
    $(this).parents(".product-mega-bundle-options").prevAll(".product-mega-bundle-options").removeClass("act-accordian");
    $(this).parents(".product-mega-bundle-options").nextAll(".product-mega-bundle-options").removeClass("act-accordian");
    $(this).parents(".product-mega-bundle-options").find(".product-mega-bundle-option-products").slideToggle();
    $(this).parents(".product-mega-bundle-options").prevAll(".product-mega-bundle-options").find(".product-mega-bundle-option-products").slideUp();
    $(this).parents(".product-mega-bundle-options").nextAll(".product-mega-bundle-options").find(".product-mega-bundle-option-products").slideUp();
  })
  
  var select = [];
  var prices = [];
  $("button.plus-cstm-inc").on("click", function(){
    prices = [];
    var get = parseInt($(this).parents(".quantity-wrapper-cstm").find("input").val());
    get += parseInt(1);
    console.log(get);
    $(this).parents(".quantity-wrapper-cstm").find("input").val(get)
    $(".product-option-item").each(function(){
      
      if ($(this).find("input[type='checkbox']").is(":checked"))
      {
        var getPrice = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("select.dynamic-options option:selected").attr("variant-price");
        var qty = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("input.cstm-input-qty-number").val();
        var price = getPrice * qty;
        console.log(price)
        prices.push(price)
      
      }
    })
    var total = 0;
    prices.forEach(function(num){total+=parseFloat(num) || 0;});
    console.log(total)
    total = parseFloat(total) / 100;
    //var newTotal = (total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var newTotal = total;
    console.log(newTotal)
    var savedMoney = discountPercentage * newTotal;
    var discountPrice = newTotal - savedMoney;
    var newCurrency = currencyFormat.replace("{{amount}}", discountPrice.toFixed(2));
    // $(".product-block.product-block--price span.product__price").text("Total Price:"+newCurrency)
    // $(".product-block.product-block--price span.product__price-savings").text(currencyFormat.replace("{{amount}}", newTotal));
    // //$(".product-block.product-block--price span.product__price-savings").removeClass("hide");
    // $(".pr-product-price").show();
    // $(".product__policies").show();
    // $(".save-money-badge-ct").show();
    // $("span.saved-money").text(savedMoney.toFixed(2))
  })
  $("button.minus-cstm-dec").on("click", function(){
    prices = [];
    var get = parseInt($(this).parents(".quantity-wrapper-cstm").find("input").val());
    if ( get > 1 )
    {
      get = parseInt(get) - parseInt(1);
    }
    console.log(get);
    $(this).parents(".quantity-wrapper-cstm").find("input").val(get)
    $(".product-option-item").each(function(){
      
      if ($(this).find("input[type='checkbox']").is(":checked"))
      {
        var getPrice = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("select.dynamic-options option:selected").attr("variant-price");
        var qty = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("input.cstm-input-qty-number").val();
        var price = getPrice * qty;
        console.log(getPrice+price)
        prices.push(price)
      
      }
    })
    var total = 0;
    prices.forEach(function(num){total+=parseFloat(num) || 0;});
    console.log(total)
    total = parseFloat(total) / 100;
    //var newTotal = (total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var newTotal = total;
    console.log(newTotal)
    var savedMoney = discountPercentage * newTotal;
    var discountPrice = newTotal - savedMoney;
    var newCurrency = currencyFormat.replace("{{amount}}", discountPrice.toFixed(2));
    // $(".product-block.product-block--price span.product__price").text("Total Price:"+newCurrency)
    // $(".product-block.product-block--price span.product__price-savings").text(currencyFormat.replace("{{amount}}", newTotal));
    // //$(".product-block.product-block--price span.product__price-savings").removeClass("hide");
    // $(".pr-product-price").show();
    // $(".product__policies").show();
    // $(".save-money-badge-ct").show();
    // $("span.saved-money").text(savedMoney.toFixed(2))
  })
  $(".product-option-info-options").find("select.select-wrapper-indiv").on("change", function(){
    select = [];
    $(this).parents(".product-option-info-options").find("select.select-wrapper-indiv").each(function(){
      var find = $(this).find("option:selected").val();
      select.push(find);
      
    })
    var arrayn = select.join(" / ");
    var getval = $(this).parents(".product-option-info-options").find("select.dynamic-options").find("option[option-title='"+arrayn+"']").val();
    $(this).parents(".product-option-info-options").find("select.dynamic-options").val(getval).trigger("change");
  
  })
  

  $(".product-option-item").find("input").on("change", function(){
    var $box = $(this);
    // if ($box.is(":checked")) {
    //   // the name of the box is retrieved using the .attr() method
    //   // as it is assumed and expected to be immutable
    //   var group = "input:checkbox[name='" + $box.attr("name") + "']";
    //   // the checked state of the group/box on the other hand will change
    //   // and the current value is retrieved using .prop() method
    //   $(group).prop("checked", false);
    //   $box.prop("checked", true);
    // } else {
    //   $box.prop("checked", false);
    // }
    prices = [];
    if ( $(this).is(":checked") )
    {
    var getImagesrc = $(this).parents(".product-option-item").find(".product-opt-img img").attr("src");
    $(".product__photos image-element img").attr("src",getImagesrc);
    $(".product__photos image-element img").attr("srcset",getImagesrc);
    $(".product__photos image-element img").attr("data-photoswipe-src",getImagesrc);
    }
    else
    {
      var getImagesrc = $(".product-option-item").find("input:checked").parents(".product-option-item").find(".product-opt-img img").attr("src");
      console.log(getImagesrc)
      if ( getImagesrc != undefined )
      {
        $(".product__photos image-element img").attr("src",getImagesrc);
        $(".product__photos image-element img").attr("srcset",getImagesrc);
        $(".product__photos image-element img").attr("data-photoswipe-src",getImagesrc);
      }
      else
      {
        var getImagesrc = $(".product-section").attr("p-f-i");
        $(".product__photos image-element img").attr("src",getImagesrc);
        $(".product__photos image-element img").attr("srcset",getImagesrc);
        $(".product__photos image-element img").attr("data-photoswipe-src",getImagesrc);
      }
    
    }
    var getSelected = $(this).parents(".product-option-item").find("select.dynamic-options option:selected").val();
    
    $(this).val(getSelected)
    $(".product-option-item").each(function(){
      
      if ($(this).find("input[type='checkbox']").is(":checked"))
      {
        var getPrice = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("select.dynamic-options option:selected").attr("variant-price");
        var qty = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("input.cstm-input-qty-number").val();
        var price = getPrice * qty;
        console.log(price)
        prices.push(price)
      
      }
    })
    var total = 0;
    prices.forEach(function(num){total+=parseFloat(num) || 0;});
    //console.log(total)
    total = parseFloat(total) / 100;
    //var newTotal = (total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var newTotal = total;
   // console.log(newTotal)
    // var savedMoney = discountPercentage * newTotal;
    // var discountPrice = newTotal - savedMoney;
    // var newCurrency = currencyFormat.replace("{{amount}}", discountPrice.toFixed(2));
    // $(".product-block.product-block--price span.product__price").text("Total Price:"+newCurrency)
    // $(".product-block.product-block--price span.product__price-savings").text(currencyFormat.replace("{{amount}}", newTotal));
    // //$(".product-block.product-block--price span.product__price-savings").removeClass("hide");
    // $(".pr-product-price").show();
    // $(".product__policies").show();
    // $(".save-money-badge-ct").show();
    // $("span.saved-money").text(savedMoney.toFixed(2))

    
  })

    $("select.dynamic-options").on("change", function(){
      var getVal = $(this).find("option:selected").val();
      var getVImage = $(this).find("option:selected").attr("variant-image");
      var getOptionprice = $(this).find("option:selected").attr("variant-default-price");
      $(this).parents(".product-option-item").find(".price-info-of-options span.option-price-in").text(getOptionprice);
      $(this).parents(".product-option-item").find(".btn-inner-price").text(getOptionprice);
      
      //console.log(getVal+"selected");
      $(this).parents(".product-option-item").find("input[type='checkbox']").val(getVal);
      $(this).parents(".product-option-item").find(".product-opt-img img").attr("src",getVImage);
      $(".product__photos image-element img").attr("src",getVImage);
      $(".product__photos image-element img").attr("srcset",getVImage);
      $(".product__photos image-element img").attr("data-photoswipe-src",getVImage);
    })
    
    var getSelected = [];
    var getOptional = [];
    var getAll = [];
    var getTitle = [];
    $("button.cst-atc-btn-cart").on("click", function(){
      var thiss = $(this);
      
      getSelected = [];
      getOptional = [];
      var getLength = $(".product-mega-bundle-options[option-required='true']").length;
      var getOptionallength = $(".product-mega-bundle-options[option-required='false']").length;
      $(".product-mega-bundle-options[option-required='true']").each(function(){
         if ( $(this).find(".selected-product-options-each .selected-product-item-in-t").length > 0 )
         {
           getSelected.push($(this).find("input[type='checkbox']:checked").val())

         }
      })
      $(".product-mega-bundle-options[option-required='false']").each(function(){
         if ( $(this).find("input[type='checkbox']").is(":checked") )
         {
           getOptional.push($(this).find("input[type='checkbox']:checked").val())

         }
      })
      //console.log(getSelected.length+" "+getLength)
      if ( getSelected.length == getLength && getSelected.length > 0 )
      {
        getAll = [];
        getTitle = [];
        $(this).addClass("btn--loading");
        getAll.push($(this).parents(".custom-atc-button-wrapper").attr("variant-id"))
        
        $(".selected-product-item-in-t").each(function(){
         
           getAll.push($(this).attr("opt-id")+"/"+$(this).attr("opt-qty"))
           getTitle.push($(this).find(".c-p-title-in").text());

      })
        console.log(getAll)
       // console.log(getTitle)
        var line_items = '';
        var unique__ID = Math.floor(Math.random() * 10000000);
        for ( var lt = 0; lt < getTitle.length; lt++ )
          {
            
            line_items += "properties[Bundle Product "+parseInt(lt+1)+"]="+getTitle[lt]+"&";
          }
        //console.log(line_items)
        setTimeout(function(){
        for ( var i = 0; i < getAll.length; i++ )
          {
            if ( i == 0 )
            {
            
            $.ajax({
              type:"POST",
              url:"/cart/add.js",
              data:"quantity=1&id="+getAll[i]+"&properties[_Unique_ID]="+unique__ID+"&properties[_Parent_Product]=True&"+line_items,
              dataType:"json",
              async:false,
              success: function(data){
              }
            })
            }
            else
            {
              var id = getAll[i].split("/");
              //console.log(id[0]+"--"+id[1]);
              $.ajax({
              type:"POST",
              url:"/cart/add.js",
              data:"quantity="+id[1]+"&id="+id[0]+"&properties[_Unique_ID]="+unique__ID+"&properties[_Child_Product]=True",
              dataType:"json",
              async:false,
              success: function(data){
              }
              })
            }
          }
          document.dispatchEvent(new CustomEvent('cart:build'));
          dra.open();
          thiss.removeClass("btn--loading");
          }, 500);
          
      }
      else if (getLength == 0)
      {
        getAll = [];
        getOptional = [];
        if ( getOptional.length == 0 )
          {
            alert("Please select options to proceed further!");
          }
        else
        {
          $(this).addClass("btn--loading");
        getAll.push($(this).parents(".custom-atc-button-wrapper").attr("variant-id"))
        $(".product-mega-bundle-options").each(function(){
         if ( $(this).find("input[type='checkbox']").is(":checked") )
         {
           getAll.push($(this).find("input[type='checkbox']:checked").val())
           getTitle.push($(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("h4").text())

         }
        })
          var unique__ID = Math.floor(Math.random() * 10000000);
          var line_items = '';
          for ( var lt = 0; lt < getTitle.length; lt++ )
          {
            
            line_items += "properties[Bundle Product "+parseInt(lt+1)+"]="+getTitle[lt]+"&";
          }
        setTimeout(function(){
        for ( var i = 0; i < getAll.length; i++ )
          {
            if ( i == 0 )
            {
            
            $.ajax({
              type:"POST",
              url:"/cart/add.js",
              data:"quantity=1&id="+getAll[i]+"&properties[_Unique_ID]="+unique__ID+"&properties[_Parent_Product]=True",
              dataType:"json",
              async:false,
              success: function(data){
              }
            })
            }
            else
            {
              $.ajax({
              type:"POST",
              url:"/cart/add.js",
              data:"quantity=1&id="+getAll[i]+"&properties[_Unique_ID]="+unique__ID+"&properties[_Child_Product]=True",
              dataType:"json",
              async:false,
              success: function(data){
              }
              })
            }
          }
          document.dispatchEvent(new CustomEvent('cart:build'));
          dra.open();
          thiss.removeClass("btn--loading");
          }, 500);
        }
      }
      else
      {
        alert("Please select required options to proceed further!");
      }
    })

  $(document).on("click", ".custom-cart-plus", function(e){
    e.preventDefault();
    e.stopPropagation();
    var getVal = $(this).siblings(".custom-cart-quantity").val();
     var newval = 1;
     newval += parseInt(getVal);
     $(this).siblings("input").val(newval).trigger("change");
     var Url = $(this).parents(".cart__item").attr("cart-remove-url");
     Url = Url.replaceAll("=0", "="+newval);
     console.log(Url)
      
  })
  $(document).on("click", ".custom-cart-minus", function(e){
    e.preventDefault();
    e.stopPropagation();
    var getVal = $(this).siblings(".custom-cart-quantity").val();
     var newval = 1;
      if ( getVal >= 1 )
      {
         newval = parseInt(getVal) - parseInt(newval);
         $(this).siblings("input").val(newval).trigger("change");
          var Url = $(this).parents(".cart__item").attr("cart-remove-url");
          Url = Url.replaceAll("=0", "="+newval);
          console.log(Url)
          
      }
     
  })
  $(document).on("change",".custom-cart-quantity", function(e){
    e.preventDefault();
    e.stopPropagation();
    var Url = $(this).parents(".cart__item").attr("cart-remove-url");
          Url = Url.replaceAll("=0", "="+$(this).val());
          console.log(Url)
          $.ajax({
            type:"POST",
            url: Url,
            dataType:"json",
            async:false,
            success: function(data){
              console.log(data)
              // document.addEventListener('ajaxProduct:added', function(evt) {
              //   console.log(evt.detail.product);
              // });
              document.dispatchEvent(new CustomEvent('cart:build'));
              // document.addEventListener('cart:updated', function(evt) {
              //   console.log(evt.detail.cart);
              // });
              
            }
          })
  })

   $(document).on("click", ".js-qty__adjust--plus.prev-plus", function(e){
    e.preventDefault();
    e.stopPropagation();
    var getVal = $(this).siblings(".js-qty__num").val();
     var newval = 1;
     newval += parseInt(getVal);
     $(this).siblings("input").val(newval).trigger("change");
     var id = $(this).parents(".cart__item").attr("data-key");
     var Url = "/cart/update?updates["+id+"]=0";
     Url = Url.replaceAll("=0", "="+newval);
     console.log(Url)
      
  })
  
  $(document).on("click", ".js-qty__adjust--minus.prev-minus", function(e){
    e.preventDefault();
    e.stopPropagation();
    var getVal = $(this).siblings(".js-qty__num").val();
     var newval = 1;
      if ( getVal >= 1 )
      {
         newval = parseInt(getVal) - parseInt(newval);
         $(this).siblings("input").val(newval).trigger("change");
          var id = $(this).parents(".cart__item").attr("data-key");
         var Url = "/cart/update?updates["+id+"]=0";
         Url = Url.replaceAll("=0", "="+newval);
          console.log(Url)
          
      }
     
  })

  $(document).on("change",".js-qty__num.main-pr-ct", function(e){
    e.preventDefault();
    e.stopPropagation();
    var id = $(this).parents(".cart__item").attr("data-key");
         var Url = "/cart/update?updates["+id+"]=0";
          Url = Url.replaceAll("=0", "="+$(this).val());
          console.log(Url)
          $.ajax({
            type:"POST",
            url: Url,
            dataType:"json",
            async:false,
            success: function(data){
              console.log(data)
              // document.addEventListener('ajaxProduct:added', function(evt) {
              //   console.log(evt.detail.product);
              // });
              document.dispatchEvent(new CustomEvent('cart:build'));
              // document.addEventListener('cart:updated', function(evt) {
              //   console.log(evt.detail.cart);
              // });
              
            }
          })
  })


  $("button.custom-opt-atc-btn").on("click", function(){
    var qty = $(this).parents(".quantity-and-cstm-atc").find("input.cstm-input-qty-number").val();
    var id = $(this).parents(".product-option-item").find("select.dynamic-options option:selected").val();
    var title = $(this).parents(".product-option-item").find("select.dynamic-options option:selected").attr("option-title");
    var price = $(this).parents(".product-option-item").find("select.dynamic-options option:selected").attr("variant-price");
    var p_id = $(this).parents(".product-option-item").attr("p-id");
    var p_title = $(this).parents(".product-option-item").attr("p-title");
    //console.log($(".selected-product-item-in-t").attr("opt-title")+"---"+title)
    var finalprice = price * qty;
    console.log(finalprice)
    if ( $(".selected-product-item-in-t[opt-title='"+title+"']").attr("opt-title") == title && $(".selected-product-item-in-t[opt-title='"+title+"']").attr("p-id") == p_id )
    {
      
      //$(".selected-product-item-in-t").each(function(){
      var getpId = $(".selected-product-item-in-t[opt-title='"+title+"']").attr("p-id");
      var getTitle = $(".selected-product-item-in-t[opt-title='"+title+"']").attr("opt-title");
      var getQty = $(".selected-product-item-in-t[opt-title='"+title+"']").attr("opt-qty");
      var p_title = $(".selected-product-item-in-t[opt-title='"+title+"']").attr("p-title");
      if ( getpId == p_id && getTitle == title )
      {
        console.log("if")
        var newQty = parseInt(qty) + parseInt(getQty);
        console.log(newQty+"--"+price+"--")
        var nPrice = price * parseInt(newQty);
        console.log(nPrice)
         $(this).parents(".product-mega-bundle-options").find(".selected-product-item-in-t[opt-title='"+getTitle+"']").html("<div class='select-flex'><span class='select-opt-title' >"+title+"</span><span class='select-p-q'> / "+newQty+"</span></div> <span class='cut-product'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-close' viewBox='0 0 64 64'><title>icon-X</title><path d='m19 17.61 27.12 27.13m0-27.12L19 44.74'></path></svg></span><span class='c-p-title-in' style='display:none;'>"+p_title+"</span>")
         $(this).parents(".product-mega-bundle-options").find(".selected-product-item-in-t[opt-title='"+getTitle+"']").attr("opt-qty",newQty);
        $(this).parents(".product-mega-bundle-options").find(".selected-product-item-in-t[opt-title='"+getTitle+"']").attr("p-price",nPrice);
        //$(".selected-product-options-each").append("<div class='selected-product-item-in-t' opt-id='"+id+"' opt-title='"+title+"' opt-qty='"+qty+"' p-id='"+p_id+"' p-price='"+price+"'><div class='select-flex'><span class='select-opt-title' >"+title+"</span><span class='select-p-q'> / "+qty+"</span></div> <span class='cut-product'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-close' viewBox='0 0 64 64'><title>icon-X</title><path d='m19 17.61 27.12 27.13m0-27.12L19 44.74'></path></svg></span></div>");
      }
      else
      {
        console.log("else")
         //$(this).parents(".product-mega-bundle-options").find(".selected-product-options-each").append("<div class='selected-product-item-in-t' opt-id='"+id+"' opt-title='"+title+"' opt-qty='"+qty+"' p-id='"+p_id+"' p-price='"+price+"'><div class='select-flex'><span class='select-opt-title' >"+title+"</span><span class='select-p-q'> / "+qty+"</span></div> <span class='cut-product'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-close' viewBox='0 0 64 64'><title>icon-X</title><path d='m19 17.61 27.12 27.13m0-27.12L19 44.74'></path></svg></span></div>");
      }
    //})
    }
    else
    {
      console.log("elseBig")
      $(this).parents(".product-mega-bundle-options").find(".selected-product-options-each").append("<div class='selected-product-item-in-t' opt-id='"+id+"' opt-title='"+title+"' opt-qty='"+qty+"' p-id='"+p_id+"' p-price='"+finalprice+"' p-title='"+p_title+"'><div class='select-flex'><span class='select-opt-title' >"+title+"</span><span class='select-p-q'> / "+qty+"</span></div> <span class='cut-product'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-close' viewBox='0 0 64 64'><title>icon-X</title><path d='m19 17.61 27.12 27.13m0-27.12L19 44.74'></path></svg></span><span class='c-p-title-in' style='display:none;'>"+p_title+"</span></div>");
    }
    
    prices = [];
    var get = parseInt($(this).parents(".quantity-wrapper-cstm").find("input").val());
    //get += parseInt(1);
    //console.log(get);
    //$(this).parents(".quantity-wrapper-cstm").find("input").val(get)
    $(".selected-product-item-in-t").each(function(){
      
      // if ($(this).find("input[type='checkbox']").is(":checked"))
      // {
      //   var getPrice = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("select.dynamic-options option:selected").attr("variant-price");
      //   var qty = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("input.cstm-input-qty-number").val();
      //   var price = getPrice * qty;
      //   console.log(price)
      //   prices.push(price)
      
      // }
      // var qty = $(this).attr("opt-qty");
      // var pricee = $(this).attr("p-price") * qty;
      prices.push($(this).attr("p-price"));
    })
    var total = 0;
    prices.forEach(function(num){total+=parseFloat(num) || 0;});
    console.log(total)
    total = parseFloat(total) / 100;
    //var newTotal = (total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var newTotal = total;
    console.log(newTotal)
    var savedMoney = discountPercentage * newTotal;
    var discountPrice = newTotal - savedMoney;
    var newCurrency = currencyFormat.replace("{{amount}}", discountPrice.toFixed(2));
    $(".product-block.product-block--price span.product__price").text("Total Price:"+newCurrency)
    $(".product-block.product-block--price span.product__price-savings").text(currencyFormat.replace("{{amount}}", newTotal));
    //$(".product-block.product-block--price span.product__price-savings").removeClass("hide");
    $(".pr-product-price").show();
    $(".product__policies").show();
    $(".save-money-badge-ct").show();
    $("span.saved-money").text(savedMoney.toFixed(2))
  })
  $(document).on("click","span.cut-product", function(e){
    var getProductId = $(this).parents(".selected-product-item-in-t").attr("p-id");
    var length = '';
    var thiss = $(this);
    var parent = $(this).parents(".product-mega-bundle-option-products");
    $(this).parents(".selected-product-item-in-t").remove();
    var len = parent.find(".selected-product-item-in-t").length;
    console.log(len)
    if ( len > 0 )
    {
      console.log(len)
      parent.find(".selected-product-item-in-t").each(function(){
      var selectId = $(this).attr("p-id");
      if ( selectId == getProductId )
      {
        length = "1";
      }
      
    })
      if ( length == "" )
      {
        parent.find(".product-option-item[p-id='"+getProductId+"'] input[type='checkbox']").prop("checked", false)
      }
    }
    else
    {
        parent.find(".product-option-item[p-id='"+getProductId+"'] input[type='checkbox']").prop("checked", false)

    }
    
    prices = [];
    var get = parseInt($(this).parents(".quantity-wrapper-cstm").find("input").val());
    //get += parseInt(1);
    //console.log(get);
    //$(this).parents(".quantity-wrapper-cstm").find("input").val(get)
    $(".selected-product-item-in-t").each(function(){
      
      // if ($(this).find("input[type='checkbox']").is(":checked"))
      // {
      //   var getPrice = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("select.dynamic-options option:selected").attr("variant-price");
      //   var qty = $(this).find("input[type='checkbox']:checked").parents(".product-option-item").find("input.cstm-input-qty-number").val();
      //   var price = getPrice * qty;
      //   console.log(price)
      //   prices.push(price)
      
      // }
      prices.push($(this).attr("p-price"));
    })
    var total = 0;
    prices.forEach(function(num){total+=parseFloat(num) || 0;});
    console.log(total)
    total = parseFloat(total) / 100;
    //var newTotal = (total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var newTotal = total;
    console.log(newTotal)
    var savedMoney = discountPercentage * newTotal;
    var discountPrice = newTotal - savedMoney;
    var newCurrency = currencyFormat.replace("{{amount}}", discountPrice.toFixed(2));
    $(".product-block.product-block--price span.product__price").text("Total Price:"+newCurrency)
    $(".product-block.product-block--price span.product__price-savings").text(currencyFormat.replace("{{amount}}", newTotal));
    //$(".product-block.product-block--price span.product__price-savings").removeClass("hide");
    $(".pr-product-price").show();
    $(".product__policies").show();
    $(".save-money-badge-ct").show();
    $("span.saved-money").text(savedMoney.toFixed(2))
  })
})